import { useEffect } from "react";
import type { IState } from "../stores/file-to-storydoc-generation.store";
import { useImportRegistry } from "../stores/import-registry.store";
import { saveImportSessions } from "../utils/import-session-storage";

// A just-resumed import is idle with its jobId kept: still saved, so the next load retries it.
const shouldPersist = (s: IState) =>
  s.jobId != null &&
  s.startedAt != null &&
  s.createdStory == null &&
  s.status !== "error";

export const usePersistImports = (userId: string | null) => {
  const imports = useImportRegistry((s) => s.imports);
  useEffect(() => {
    if (!userId) return;
    const save = () => {
      const registry = useImportRegistry.getState();
      if (registry.ownerId !== userId) return;
      saveImportSessions(
        userId,
        registry.imports.map((i) => i.store.getState()).filter(shouldPersist),
      );
    };
    save();
    const unsubscribe = imports.map((i) => i.store.subscribe(save));
    return () => unsubscribe.forEach((u) => u());
  }, [userId, imports]);
};
